export type WHeadingLevel = 1 | 2 | 3 | 4 | 5 | 6 | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | '1' | '2' | '3' | '4' | '5' | '6';

/** normalize heading level input (number or 'hN') to 1..6, otherwise fallback */
export function toHeadingLevel(value: WHeadingLevel | string | number | null | undefined, fallback: number): number {
  const level = typeof value === 'string' ? +value.replace(/^h/i, '') : value;
  return typeof level === 'number' && Number.isInteger(level) && level >= 1 && level <= 6 ? level : fallback;
}
